import { useQuery } from "@tanstack/react-query";
import { cfOrdersApi } from "./client";

export const cfOrdersKeys = {
  all: ["cf-orders"] as const,
  list: (params: {
    q?: string;
    status?: string;
    source?: string;
    feedType?: "post" | "live";
    limit?: number;
    offset?: number;
  }) => [...cfOrdersKeys.all, "list", params] as const,
  counts: () => [...cfOrdersKeys.all, "status-counts"] as const,
  detail: (id: string | null) => [...cfOrdersKeys.all, "detail", id] as const,
};

export function useCfOrdersList(params: {
  q?: string;
  status?: string;
  source?: string;
  feedType?: "post" | "live";
  limit?: number;
  offset?: number;
}) {
  return useQuery({
    queryKey: cfOrdersKeys.list(params),
    queryFn: () => cfOrdersApi.list(params),
  });
}

export function useCfOrderStatusCounts() {
  return useQuery({
    queryKey: cfOrdersKeys.counts(),
    queryFn: () => cfOrdersApi.statusCounts(),
  });
}

export function useCfOrderDetail(orderId: string | null) {
  return useQuery({
    queryKey: cfOrdersKeys.detail(orderId),
    queryFn: () => cfOrdersApi.getById(orderId!),
    enabled: Boolean(orderId),
  });
}
